import { render, staticRenderFns } from "./individus-list.vue?vue&type=template&id=56cac73c&scoped=true&"
import script from "./individus-list.vue?vue&type=script&lang=ts&"
export * from "./individus-list.vue?vue&type=script&lang=ts&"
import style0 from "./individus-list.vue?vue&type=style&index=0&id=56cac73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cac73c",
  null
  
)

export default component.exports